// extracted by mini-css-extract-plugin
export default {"noRouteLocations":"bringg-map-route-player_noRouteLocations__xMq5A"};